import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';
import {
  BrowserRouter as Router,
  Route,
  Switch
} from "react-router-dom";
import {
  withStyles
} from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import ThemeProvider from 'components/Theme';
import HomeOestro from 'components/HomeOestro/HomeOestro';
import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
import NoMatch from 'components/NoMatch';
import Contact from 'components/Contact/Contact';

// import Legal from 'components/Legal/Legal';
// import Confidentiality from 'components/Confidentiality/Confidentiality';
import CMSPage from 'components/UI/Cms/CMSPage';

import queryString from 'query-string';
import {
  login as initialeLogin,
  isStateKnown as authStateKnown,
  // getCurrentUserRole,
  // isLoggedIn,
} from 'components/UI/Account/ducks/authentication';
import '../App.css';
const styles = {
  drawerPaper: {
    top: 40,
    zIndex: 998,
    borderRadius: '0 0 5px 5px',
    padding: '5px 3px'
  },
  drawerModal: {
    zIndex: 997
  }
};
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      panelOpened: false
    };
    this._panelToggle = this._panelToggle.bind(this);
  }
  componentDidMount() {
    this.props.onMount();
  }
  _panelToggle() {
    this.setState({
      panelOpened: !this.state.panelOpened
    });
  }
  render() {
    const {
      // loggedIn,
      // userRole,
      authStateKnown,
      // classes,
      // width,
      // $$data
    } = this.props;
    return (<div className="App">
      <ThemeProvider>
        <CssBaseline/>
        <ScrollToTopOnMount/>
        <If condition={authStateKnown === true}>
        <Router>
          <Switch>
            <Route exact={true} path={'/'} component={({match}) => (<HomeOestro/>)}/>


            <Route path={'/legal'} component={() => <CMSPage page={'legal'} headerProps={{showMenu: false}}/>}/>
            <Route path={'/confidentiality'} component={() => <CMSPage page={'confidentiality'} headerProps={{showMenu: false}}/>}/>
            <Route path={'/cookies'} component={() => <CMSPage page={'cookies'} headerProps={{showMenu: false}}/>}/>
              <Route exact={true} path={'/contact'} component={({match}) => (<Contact showHelp={false}/>)}/>

            <Route component={() => <NoMatch/>}/>

          </Switch>
        </Router>
        </If>
      </ThemeProvider>
    </div>);
  }
}

function mapStateToProps(state) {
  const props = {
    authStateKnown: authStateKnown(state),
    // loggedIn: isLoggedIn(state),
    // userRole: getCurrentUserRole(state),
  };
  return props;
}

function mapDispatchToProps(dispatch) {
  return {
    onMount: () => {
      const uri = queryString.parse(window.location.search);
      return dispatch(initialeLogin({
        referer: uri.r
      }));
    }
  };
}
export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/components/AppOestro.js